export const visit = (vm, at) => {
at({ "hu": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Probl\xE9ma volt a h\xE1l\xF3zati kapcsolattal.", "message": "Ellen\u0151rizze a kapcsolat\xE1t, \xE9s pr\xF3b\xE1lkozzon \xFAjra.", "button": "Ism\xE9t" } } } } });
};